
<div class="content-settings" *ngIf="deviceSettingsService">
  <div class="settings">
    <div class="col">
      <video id="userCam" muted [attr.playsinline]="true"
  [attr.webkit-playsinline]="true" ></video>
      <div class="mic">
        <div class="mic-icon">
          <img src="assets/icons/microphone-01.svg" [alt]="('settings.MICROPHONE_ALT' | transloco)">
        </div>
        <div class="mic-text">{{'settings.MICROPHONE' | transloco}}</div>
        <div class="circles">
          <div class="circle" [class.circle-active]="deviceSettingsService.decibels >= -22"></div>
          <div class="circle" [class.circle-active]="deviceSettingsService.decibels >= -21"></div>
          <div class="circle" [class.circle-active]="deviceSettingsService.decibels >= -20"></div>
          <div class="circle" [class.circle-active]="deviceSettingsService.decibels >= -19"></div>
          <div class="circle" [class.circle-active]="deviceSettingsService.decibels >= -18"></div>
          <div class="circle" [class.circle-active]="deviceSettingsService.decibels >= -17"></div>
          <div class="circle" [class.circle-active]="deviceSettingsService.decibels >= -16"></div>
          <div class="circle" [class.circle-active]="deviceSettingsService.decibels >= -15"></div>
          <div class="circle" [class.circle-active]="deviceSettingsService.decibels >= -14"></div>
          <div class="circle" [class.circle-active]="deviceSettingsService.decibels >= -13"></div>
          <div class="circle" [class.circle-active]="deviceSettingsService.decibels >= -12"></div>
          <div class="circle" [class.circle-active]="deviceSettingsService.decibels >= -11"></div>
        </div>
      </div>

      <!-- Diagnostic callout below mic -->
      <app-device-settings-diagnostic *ngIf="isTavusCall" [deviceSettingsService]="deviceSettingsService" (diagnosticRunningChange)="diagnosticRunningChange.emit($event)"></app-device-settings-diagnostic>
    </div>
    <div class="col">

      <!-- Microphone -->
      <div class="select">
        <div class="select-label">{{'settings.SELECT_MICROPHONE' | transloco}}</div>
        <div class="select-item">
          <div class="select-icon">
            <img src="assets/icons/microphone-01-gray.svg" [alt]="('settings.MICROPHONE_ALT' | transloco)">
          </div>
          <!-- Error message -->
          <div class="select-input select-error" *ngIf="deviceSettingsService.audioDeviceError">
            <img src="assets/icons/alert-circle.svg" [alt]="('settings.ALERT' | transloco)">
            {{ deviceSettingsService.audioDevicePlaceholder }}
          </div>
          <!-- Select input -->
          <mat-select *ngIf="!deviceSettingsService.audioDeviceError"
            [(value)]="deviceSettingsService.audioDeviceSelected"
            [disabled]="!deviceSettingsService.displayAudioOptions"
            [class.hide-arrow]="!deviceSettingsService.displayAudioOptions || deviceSettingsService.audioDeviceOptions.length < 2"
            [disabled]="!deviceSettingsService.displayAudioOptions || deviceSettingsService.audioDeviceOptions.length < 2"
            (selectionChange)="handleSelectMicClick()"
            [placeholder]="deviceSettingsService.audioDevicePlaceholder"
            panelClass="device-settings-content-mat-select">
            <mat-option *ngFor="let item of deviceSettingsService.audioDeviceOptions" [value]="item.deviceId">
              {{ item.label || "Default Mic" }}
            </mat-option>
          </mat-select>
          <!-- Give Permission button -->
          <quant-button type="button" hierarchy="primary-disabled-dark" size="md"
            *ngIf="deviceSettingsService.isPermissionDismissedAudio" [label]="('settings.GIVE_PERMISSION' | transloco)"
            (click)="deviceSettingsService.givePermission(deviceSettingsService.audioDevice)">
          </quant-button>
        </div>
      </div>

      <!-- Video -->
      <div class="select">
        <div class="select-label">{{'settings.SELECT_VIDEO_DEVICE' | transloco}}</div>
        <div class="select-item">
          <div class="select-icon">
            <img src="assets/icons/video-outline.svg" [alt]="('settings.VIDEO' | transloco)">
          </div>
          <!-- Error message -->
          <div class="select-input select-error" *ngIf="deviceSettingsService.videoDeviceError">
            <img src="assets/icons/alert-circle.svg" [alt]="('settings.ALERT' | transloco)">
            {{deviceSettingsService.videoDevicePlaceholder }}
          </div>
          <!-- Select input -->
          <mat-select class="select" *ngIf="!deviceSettingsService.videoDeviceError"
            [(value)]="deviceSettingsService.videoDeviceSelected"
            (selectionChange)="handleSelectCamClick()"
            [class.hide-arrow]="deviceSettingsService.videoDeviceOptions.length < 2"
            [disabled]="deviceSettingsService.videoDeviceOptions.length < 2"
            [placeholder]="deviceSettingsService.videoDevicePlaceholder"
            panelClass="device-settings-content-mat-select">
            <mat-option *ngFor="let item of deviceSettingsService.videoDeviceOptions" [value]="item.deviceId">
              {{ item.label }}
            </mat-option>
          </mat-select>
          <!-- Give Permission button -->
          <quant-button type="button" hierarchy="primary-disabled-dark" size="md"
            *ngIf="deviceSettingsService.isPermissionDismissedVideo" [label]="('settings.GIVE_PERMISSION' | transloco)"
            (click)="deviceSettingsService.givePermission(deviceSettingsService.videoDevice)">
          </quant-button>
        </div>
      </div>

      <!-- Error message -->
      <div class="error-message" *ngIf="deviceSettingsService.isDeviceBlocked">
        {{'settings.DEVICE_BLOCKED_ERROR' | transloco}}
      </div>
    </div>
  </div>
</div>
